<template>
  <div class="welcome-page">
    <div v-if="isLoading" class="loading-spinner"></div>
    <h1 v-else class="welcome-text">{{ welcomeText }}</h1>
  </div>
</template>

<script>
import { fetchScreenData } from '../utils/api.js'

export default {
  name: 'WelcomePage',
  data() {
    return {
      welcomeText: '',
      isLoading: true
    }
  },
  mounted() {
    this.loadWelcomeText()
  },
  watch: {
    '$route.query': {
      handler() {
        this.loadWelcomeText()
      }
    }
  },
  methods: {
    async loadWelcomeText() {
      try {
        const data = await fetchScreenData()
        this.welcomeText = data || '欢迎使用飞米系统'
      } catch (error) {
        console.error('获取欢迎语失败:', error)
        this.welcomeText = '欢迎使用飞米系统'
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.welcome-page {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0a1628;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 3px solid rgba(99, 179, 237, 0.3);
  border-top-color: #63b3ed;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.welcome-text {
  font-size: 64px;
  font-weight: 700;
  color: #e2e8f0;
  text-shadow: 0 0 30px rgba(99, 179, 237, 0.5);
  text-align: center;
  padding: 0 60px;
  animation: fadeIn 1s ease-out;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
